(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collectionslider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    if (window.PremiumCollectionSlider) {
      return;
    }

    var SELECTOR = '[data-pics]';
    var registry = new Map();

    function Slider(root) {
      this.root = root;
      this.viewport = root.querySelector('[data-pics-viewport]');
      this.track = root.querySelector('[data-pics-track]');
      this.loop = root.getAttribute('data-loop') === 'true';
      this.reverse = root.getAttribute('data-direction') === 'right';
      this.pauseTouch = root.getAttribute('data-pause-touch') === 'true';
      this.reasons = {};
      this.lastWidth = -1;
      this.groupWidth = 0;
      this.raf = 0;
      this.handlers = null;
      this.ro = null;
      this.io = null;
      this.init();
    }

    Slider.prototype.setPause = function (reason, on) {
      if (on) {
        this.reasons[reason] = true;
      } else {
        delete this.reasons[reason];
      }
      this.root.classList.toggle('is-paused', Object.keys(this.reasons).length > 0);
    };

    Slider.prototype.makeClone = function (base) {
      var clone = base.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('data-pics-clone', '');
      Array.prototype.forEach.call(clone.querySelectorAll('a, button, [tabindex]'), function (el) {
        el.setAttribute('tabindex', '-1');
      });
      Array.prototype.forEach.call(clone.querySelectorAll('[data-shopify-editor-block]'), function (el) {
        el.removeAttribute('data-shopify-editor-block');
      });
      return clone;
    };

    Slider.prototype.build = function () {
      var track = this.track;
      var root = this.root;
      var groups = track.querySelectorAll('[data-pics-group]');
      var base = groups[0];
      var i;

      if (!base) {
        return;
      }

      for (i = 1; i < groups.length; i++) {
        track.removeChild(groups[i]);
      }

      root.classList.remove('pics--fit');

      var vw = this.viewport.clientWidth;
      var gw = base.getBoundingClientRect().width;

      if (!vw || !gw) {
        return;
      }

      this.groupWidth = gw;

      if (!this.loop) {
        var last = base.lastElementChild;
        var baseRect = base.getBoundingClientRect();
        var lastRect = last ? last.getBoundingClientRect() : baseRect;
        var dist = Math.max(0, Math.round(lastRect.right - baseRect.left - vw));
        if (dist < 2) {
          root.classList.add('pics--fit');
        } else {
          track.style.setProperty('--pics-shift', (-dist) + 'px');
        }
        return;
      }

      var needed = Math.min(12, Math.max(2, Math.ceil(vw / gw) + 1));
      for (i = 1; i < needed; i++) {
        track.appendChild(this.makeClone(base));
      }
      track.style.setProperty('--pics-shift', (-100 / needed) + '%');
    };

    Slider.prototype.reveal = function (el) {
      if (!this.loop || !this.groupWidth) {
        return;
      }

      try {
        var anims = this.track.getAnimations ? this.track.getAnimations() : [];
        var anim = anims[0];
        if (!anim || !anim.effect) {
          return;
        }

        var item = el.closest('[data-pics-item]') || el;
        var vr = this.viewport.getBoundingClientRect();
        var ir = item.getBoundingClientRect();
        var pad = 16;

        if (ir.left >= vr.left + pad && ir.right <= vr.right - pad) {
          return;
        }

        var tr = this.track.getBoundingClientRect();
        var itemLeft = ir.left - tr.left;
        var x = (vr.width - ir.width) / 2 - itemLeft;
        var w = this.groupWidth;
        x = Math.max(-w, Math.min(0, x));

        var p = (-x) / w;
        var d = anim.effect.getComputedTiming().duration;
        if (typeof d !== 'number' || !isFinite(d)) {
          return;
        }
        anim.currentTime = (this.reverse ? 1 - p : p) * d;
      } catch (err) {
        return;
      }
    };

    Slider.prototype.bind = function () {
      var self = this;
      var vp = this.viewport;

      this.handlers = {
        down: function (e) {
          if (self.pauseTouch && e.pointerType !== 'mouse') {
            self.setPause('touch', true);
          }
        },
        up: function () {
          self.setPause('touch', false);
        },
        focusin: function (e) {
          var visible = true;
          try {
            visible = e.target.matches(':focus-visible');
          } catch (err) {
            visible = true;
          }
          if (visible) {
            self.setPause('focus', true);
            self.reveal(e.target);
          }
        },
        focusout: function (e) {
          var next = e.relatedTarget;
          if (next && vp.contains(next)) {
            return;
          }
          self.setPause('focus', false);
        },
        visibility: function () {
          if (document.hidden) {
            self.setPause('touch', false);
          }
        },
        resize: function () {
          self.scheduleBuild();
        }
      };

      var h = this.handlers;
      vp.addEventListener('pointerdown', h.down, { passive: true });
      vp.addEventListener('pointerup', h.up, { passive: true });
      vp.addEventListener('pointercancel', h.up, { passive: true });
      vp.addEventListener('touchend', h.up, { passive: true });
      vp.addEventListener('touchcancel', h.up, { passive: true });
      vp.addEventListener('focusin', h.focusin);
      vp.addEventListener('focusout', h.focusout);
      document.addEventListener('visibilitychange', h.visibility);
    };

    Slider.prototype.scheduleBuild = function () {
      var self = this;
      var width = this.viewport.clientWidth;
      if (width === this.lastWidth) {
        return;
      }
      this.lastWidth = width;
      cancelAnimationFrame(this.raf);
      this.raf = requestAnimationFrame(function () {
        self.build();
      });
    };

    Slider.prototype.init = function () {
      var self = this;

      this.build();
      this.lastWidth = this.viewport.clientWidth;
      this.bind();

      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(function () {
          self.scheduleBuild();
        });
        this.ro.observe(this.viewport);
      } else {
        window.addEventListener('resize', this.handlers.resize);
      }

      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              self.root.classList.toggle('is-offscreen', !entry.isIntersecting);
            });
          },
          { rootMargin: '100px' }
        );
        this.io.observe(this.root);
      }
    };

    Slider.prototype.destroy = function () {
      var vp = this.viewport;
      var h = this.handlers;

      if (h) {
        vp.removeEventListener('pointerdown', h.down);
        vp.removeEventListener('pointerup', h.up);
        vp.removeEventListener('pointercancel', h.up);
        vp.removeEventListener('touchend', h.up);
        vp.removeEventListener('touchcancel', h.up);
        vp.removeEventListener('focusin', h.focusin);
        vp.removeEventListener('focusout', h.focusout);
        document.removeEventListener('visibilitychange', h.visibility);
        window.removeEventListener('resize', h.resize);
      }
      if (this.ro) {
        this.ro.disconnect();
      }
      if (this.io) {
        this.io.disconnect();
      }
      cancelAnimationFrame(this.raf);
      this.root.classList.remove('is-paused', 'is-offscreen');
      this.reasons = {};
      this.handlers = null;
    };

    function init(root) {
      if (!root || registry.has(root)) {
        return;
      }
      if (root.getAttribute('data-autoplay') !== 'true') {
        return;
      }
      if (!root.querySelector('[data-pics-viewport]') || !root.querySelector('[data-pics-track]')) {
        return;
      }
      registry.set(root, new Slider(root));
    }

    function destroy(root) {
      var instance = registry.get(root);
      if (instance) {
        instance.destroy();
        registry.delete(root);
      }
    }

    function eachRoot(scope, callback) {
      if (!scope || !scope.querySelectorAll) {
        return;
      }
      if (scope.matches && scope.matches(SELECTOR)) {
        callback(scope);
      }
      Array.prototype.forEach.call(scope.querySelectorAll(SELECTOR), callback);
    }

    function instanceFor(el) {
      var root = el && el.closest ? el.closest(SELECTOR) : null;
      return root ? registry.get(root) : null;
    }

    function initAll() {
      eachRoot(document, init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      eachRoot(event.target, init);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      eachRoot(event.target, destroy);
    });

    document.addEventListener('shopify:block:select', function (event) {
      var instance = instanceFor(event.target);
      if (instance) {
        instance.setPause('editor', true);
        instance.reveal(event.target);
      }
    });

    document.addEventListener('shopify:block:deselect', function (event) {
      var instance = instanceFor(event.target);
      if (instance) {
        instance.setPause('editor', false);
      }
    });

    window.PremiumCollectionSlider = { init: init, destroy: destroy };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
